import { render, staticRenderFns } from "./BaseSetMap.vue?vue&type=template&id=54924865"
import script from "./BaseSetMap.vue?vue&type=script&lang=js"
export * from "./BaseSetMap.vue?vue&type=script&lang=js"
import style0 from "./BaseSetMap.vue?vue&type=style&index=0&id=54924865&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports